import { put, take, call } from 'redux-saga/effects';
import { GET_CANBUS_TROUBLESHOOTS_TUTORIAL_REQUEST } from './types';
import {
  getCanbusTroubleshootTutorialError,
  getCanbusTroubleshootTutorialSuccess,
} from './actions';
import withLoading from '../../../sagas/loadingSaga';

export default function* canbusTroubleshootTutorialSaga(api) {
  while (true) {
    const canbusTroubleshootTutorialAction = yield take(
      GET_CANBUS_TROUBLESHOOTS_TUTORIAL_REQUEST,
    );
    yield* withLoading(function* () {
      const { domainName } = canbusTroubleshootTutorialAction.payload;
      yield call(getTroubleshootTutorial, api, domainName);
    });
  }
}

function* getTroubleshootTutorial(api, domainName) {
  try {
    const canbusTroubleshootTutorialResponse = yield call(
      api.getTroubleshootTutorialsData,
      domainName,
    );
    yield put(
      getCanbusTroubleshootTutorialSuccess({
        canbusTroubleshootTutorialResponse:
          canbusTroubleshootTutorialResponse.data,
      }),
    );
  } catch (error) {
    yield put(getCanbusTroubleshootTutorialError(error));
  }
}
